import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
//import { Observable } from 'rxjs';
//import { AuthService } from 'src/app/applicationModules/authentication/services/auth/auth.service';
import { CommonService } from '../../common/common.service';

@Injectable({
  providedIn: 'root'
})
export class EcmAuthgaurdGuard implements CanActivate {

/**
 *
 */
constructor(private router: Router,
  private commonService: CommonService) { 

}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let token = sessionStorage.getItem('userToken')
    //const currentUser = this.commonService.getLoggedInUserDetails();
    if(token != undefined && token != null && token != '') {
      return true;
    } else{
      this.router.navigate(['/auth/login']);
      return false;
    }

}
  
}
